import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_CULTURES]: {
		url: '/company/:companyId/reports/cultures/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_FIELDS]: {
		url: '/company/:companyId/reports/fields/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_MATERIALS_VOLUMES]: {
		url: '/company/:companyId/reports/materials_volumes/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_PRODUCT_VOLUMES]: {
		url: '/company/:companyId/reports/product_volumes/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS].GET_REPORTS_RELATED_OBJECTS]: {
		url: '/company/:companyId/reports/related_objects/',
	},
}
